export default __webpack_public_path__ + "static/media/menion.dc455850.png";